/**
 * Formatação de datas do cadastro.
 *
 * `timeZone: 'UTC'` é intencional: a API serializa um `DATETIME` sem timezone
 * como se fosse UTC, então os componentes "UTC" da data são exatamente o
 * horário de Brasília que foi gravado. Formatar em UTC devolve o valor
 * original sem depender de horário de verão nem do fuso do navegador.
 */

const dateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'UTC',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatRegisteredAt(date: Date | null): string {
  return date ? dateTimeFormatter.format(date) : '—';
}

/** Data e hora separadas, para exibir em duas linhas na tabela. */
export function formatRegisteredAtParts(date: Date | null): { date: string; time: string | null } {
  if (!date) return { date: '—', time: null };
  return { date: dateFormatter.format(date), time: timeFormatter.format(date) };
}

const numberFormatter = new Intl.NumberFormat('pt-BR');

export function formatCount(value: number): string {
  return numberFormatter.format(value);
}

/** "1 inscrição" / "12 inscrições" — evita o "1 registros" do painel antigo. */
export function pluralize(count: number, singular: string, plural: string): string {
  return `${formatCount(count)} ${count === 1 ? singular : plural}`;
}
